/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeTenantsListComputeTenants } from "../../funcs/computeTenantsListComputeTenants.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListComputeTenantsRequest$inboundSchema,
};

export const tool$computeTenantsListComputeTenants: ToolDefinition<
  typeof args
> = {
  name: "compute-tenants-list-compute-tenants",
  description: `List tenants

Cluster-administrator-only.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeTenantsListComputeTenants(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
